import Vue from 'vue'
import Vuex, {StoreOptions} from 'vuex'
import  { RootState } from './types'
import {user} from '@/store/modules/user/index'
import {menus} from '@/store/modules/menus/index'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
    state: {
        version: '1.0.0'
    },
    modules: {
        user : user,
        menus : menus
       
    },
    devtools: false
}

export default new Vuex.Store<RootState>(store)
